// @flow

import React from 'react'
import styled from 'styled-components'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import { type PropTypes as FavoriteListItemPropTypes } from 'components/molecules/FavoriteListItem'
import Loading from 'components/atoms/Loading'
import ModalFullScreen from 'components/molecules/ModalFullScreen'
import ModalHeadline from 'components/molecules/ModalHeadline'
import CardSelect from 'components/molecules/CardSelect'
import CreateListForm from 'components/molecules/CreateListForm'

const LoadingContainer = styled.div`
  text-align: center;
`

const CreateListFormWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`

const FavoriteSelectListContainer = styled.div`
  margin-top: ${spacing.medium_2}px;
  ${mediaMin.phone`
    margin-top: ${spacing.medium}px;
  `};
`

const CardSelectList = styled.ul`
  ${mediaMin.phone`
    margin: -${spacing.medium_2}px 0 0 -${spacing.medium_2}px;
  `};
`

const CardSelectListItem = styled.li`
  display: inline-block;
  width: 50%;
  :nth-child(odd) {
    padding-right: ${spacing.small_2}px;
  }
  :nth-child(even) {
    padding-left: ${spacing.small_2}px;
  }
  &:not(:nth-child(-n + 2)) {
    margin: ${spacing.medium}px 0 0 0;
  }
  ${mediaMin.phone`
    margin: ${spacing.medium_2}px 0 0 ${spacing.medium_2}px;
    width: 184px;
    :nth-child(odd) {
      padding-right: 0;
    }
    :nth-child(even) {
      padding-left: 0;
    }
    &:not(:nth-child(-n+2)) {
      margin: ${spacing.medium_2}px 0 0 ${spacing.medium_2}px;
    }
  `};
`

const FavoriteSelectModalCaution = styled.p`
  margin-top: ${spacing.medium_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: center;
`

const CardSelectListContainer = styled.div`
  margin-top: ${spacing.medium_2}px;
`

type PropTypes = {
  show: boolean,
  favoriteList: Array<FavoriteListItemPropTypes>,
  openInputFavoriteName: boolean,
  registeredFavoriteLists: Array<number>,
  onChangeFavoriteListName: Function,
  onClickClose: Function,
  onClickOpenInputFavorite: Function,
  onClickCloseInputFavorite: Function,
  onClickCreateFavoriteList: Function,
  onClickAddFavoriteList: Function,
  onClickRemoveFavoriteList: Function,
  loading: boolean,
  errorMessage: string,
}

export default (props: PropTypes) => {
  const {
    show,
    favoriteList,
    registeredFavoriteLists,
    onClickClose,
    openInputFavoriteName,
    onChangeFavoriteListName,
    onClickOpenInputFavorite,
    onClickCloseInputFavorite,
    onClickCreateFavoriteList,
    errorMessage,
    onClickAddFavoriteList,
    onClickRemoveFavoriteList,
  } = props

  return (
    <ModalFullScreen
      isActive={show}
      onClickClose={onClickClose}
      large
      fixedCloseButton
    >
      <ModalHeadline
        title={i18n.t('favorite.chooseList')}
        textList={[
          i18n.t('favorite.chooseListDesc1'),
          i18n.t('favorite.chooseListDesc2'),
        ]}
      />
      <CreateListFormWrapper>
        <CreateListForm
          openInputFavoriteName={openInputFavoriteName}
          title={i18n.t('favorite.createNewList')}
          placeholder={i18n.t('favorite.inputPlaceholder')}
          createFormAddText={i18n.t('favorite.createNewList')}
          errorMessage={errorMessage}
          description={i18n.t('favorite.inputGuide')}
          onChangeFavoriteListName={onChangeFavoriteListName}
          onClickOpenInputFavorite={onClickOpenInputFavorite}
          onClickCloseInputFavorite={onClickCloseInputFavorite}
          onClickCreateFavoriteList={onClickCreateFavoriteList}
        />
      </CreateListFormWrapper>
      <FavoriteSelectListContainer>
        <CardSelectListContainer>
          {Array.isArray(favoriteList) && favoriteList.length ? (
            <CardSelectList>
              {favoriteList.map((favoriteItem, i) => (
                <CardSelectListItem key={`favorite_item_${i}`}>
                  <CardSelect
                    {...favoriteItem}
                    checked={registeredFavoriteLists.includes(favoriteItem.id)}
                    onClickAddFavoriteList={onClickAddFavoriteList}
                    onClickRemoveFavoriteList={onClickRemoveFavoriteList}
                  />
                </CardSelectListItem>
              ))}
            </CardSelectList>
          ) : null}
        </CardSelectListContainer>
        {props.loading && (
          <LoadingContainer>
            <Loading size={32} />
          </LoadingContainer>
        )}
      </FavoriteSelectListContainer>
      <FavoriteSelectModalCaution>
        {i18n.t('favorite.explain')}
      </FavoriteSelectModalCaution>
    </ModalFullScreen>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/FavoriteSelectModal/index.jsx